import { config } from "../utilities/configs";
import { http } from "../utilities/http";

let ConsultationService = {
  add: async (request) => {
    const resp = await http.post(config.baseUrl + "/consultation/book", request);
    return resp;
  },
  getServices: async () => {
    const resp = await http.get(config.baseUrl + "/consultation/service/list");
    return resp;
  },
};

export { ConsultationService }; 